import {useEffect} from 'react';
import {useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State, store} from '@App/state'
import {bindActionCreators} from "@reduxjs/toolkit";
import {apolloClient} from "@App/graphql/client";
import {
    GET_ORGANIZATION_PREMIUM_SERVICES,
    OrganizationPremiumServicesQuery
} from "@App/graphql/queries/getOrganizationPremiumServices";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const usePremiumServiceParameters = () => {

    const dispatch = useDispatch();
    const {addPremiumService} = bindActionCreators(actionCreators, dispatch)
    const [searchParams] = useSearchParams()

    const organization = useSelector((state: State) => state.orders.organization)
    const premiumServices = useSelector((state: State) => state.orders.premiumServices)
    const premiumServiceQuery = searchParams.get('premiumservices')
    const serviceQuery = parseInt(searchParams.get('service'))


    useEffect(() => {
        if (serviceQuery && premiumServiceQuery){
            const premiumServicesToSet = premiumServiceQuery.split(',')

            apolloClient.query<OrganizationPremiumServicesQuery>({
                query: GET_ORGANIZATION_PREMIUM_SERVICES,
                variables: {
                    organization: organization.id,
                    services: [serviceQuery]
                }
            }).then((result) => {
                result.data.organization.premium_services?.forEach((orgPremiumService) => {
                    if (premiumServicesToSet.some(p => parseInt(p) == orgPremiumService.id)) {
                        let isSet = premiumServices.some(p => p.id == orgPremiumService.id)
                        if(!isSet) {
                            addPremiumService(orgPremiumService)
                        }
                    }
                })
            })
        }

    }, [])

    const premiumServiceQueryParams = () => {
        return {
            // add service if existing
            ...(store.getState().orders.premiumServices && {
                premiumServices: store.getState().orders.premiumServices.map((premiumService) => premiumService.id).join(',')
            }),
        }
    }

    return {premiumServiceQueryParams}
}

